import { action, atom, map } from "nanostores";
import AWS from "aws-sdk";
import { formatBytes } from "../utils";

const bucketName = "cdn.rx.dev";

AWS.config.region = "us-east-1";

type Object = {
  name: string;
  size?: string;
  lastModified?: string;
  type: "file" | "folder";
};

const client = new AWS.S3({
  apiVersion: "2006-03-01",
  params: {
    Bucket: bucketName,
  },
  credentials: null,
});

const state = map<{
  objects: Object[];
  folders: Number;
  files: Number;
}>({
  objects: [],
  folders: 0,
  files: 0,
});

const getObjects = action(
  state,
  "getObjects",
  async (store, { prefix }: { prefix: string } = { prefix: "" }) => {
    const data: AWS.S3.ListObjectsOutput = await client
      .makeUnauthenticatedRequest("listObjectsV2", {
        Bucket: bucketName,
        Delimiter: "/",
        Prefix: prefix,
      })
      .promise();
    let files: Object[] =
      data.Contents?.filter(
        (x) => x.Key != "index.html" && x.Key != "asset-manifest.json" && x.Key?.charAt(x.Key?.length - 1) !== "/"
      ).map((x) => ({
        name: x.Key!,
        size: x.Size ? formatBytes(x.Size) : undefined,
        lastModified: x.LastModified?.toISOString(),
        type: "file",
      })) || [];
    let folders: Object[] =
      data.CommonPrefixes?.filter((x) => x.Prefix !== "static/").map((x) => ({
        name: x.Prefix!,
        size: "-",
        lastModified: "-",
        type: "folder",
      })) || [];
    store.setKey("objects", folders.concat(files));
    store.setKey("files", files.length);
    store.setKey("folders", folders.length);
  }
);

// const getObjects = async (prefix: string = "") => {
//     const data: AWS.S3.ListObjectsOutput = await client.makeUnauthenticatedRequest("listObjectsV2", {
//         Bucket: bucketName,
//         Delimiter: '/',
//         Prefix: prefix
//     }).promise()
//     let files: Object[] = data.Contents?.map((x) => ({
//         name: x.Key!,
//         size: x.Size ? formatBytes(x.Size) : undefined,
//         lastModified: x.LastModified?.toISOString(),
//         type: "file"
//     })) || [];
//     let folders: Object[] = data.CommonPrefixes?.map((x) => ({
//         name: x.Prefix!,
//         size: undefined,
//         lastModified: undefined,
//         type: "folder"
//     })) || [];
//     state.set(files.concat(folders));
// }

export const store = {
  state: state,
  actions: {
    getObjects,
  },
};
